import { useTranslations } from "../../contexts/Translation";
import { Plus } from "../Icons";
import { useNavigate } from "react-router-dom";
import styles from "./CreateImprovementGoalLink.module.css";

type ComponentProps = {
  from: string;
}

export const CreateImprovementGoalLink = ({ from }: ComponentProps) => {
  const t = useTranslations("improvementGoals");
  const navigate = useNavigate();

  const navFunc = () => {
    navigate(`/organization/goal?fromDate=${from}`);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className={styles.root}>
      <button className={styles.link} onClick={navFunc} type='button'>
        <Plus width='32px' height='32px' /> {t("create")}
      </button>
    </div>
  );
};
